<template>
<div>

  <div id="pageContent">
    <div id="formArea" class="borderBox">
      <loader v-show="loading" style="width: 200px;height: 200px"></loader>
      <div v-show="!loading">
        <h3>Получить логин/email по коду менеджера</h3>
        <input v-model="managerCode" v-mask="'#######'">
        <button v-on:click="findUser">Поиск</button>
        <p style="margin: 10px 0">{{resultFind}}</p>
      </div>
      <hr>
      <div v-show="!loading">
        <h3>Обновить статус пользователей портала</h3>
        <button v-on:click="updateUsers">Запустить процесс обновления</button>
        <div>{{resultUpdate}}</div>
      </div>
    </div>
  </div>
</div>
</template>

<script>
export default {
  name: "usersUpdate",
  data(){
    return {
      managerCode:null,
      resultFind:'',
      resultUpdate:{},
      loading:false,
    }
  },
  components: {
    loader: () => import('@/components/loader'),
  },
  methods:{
    findUser(){
      this.loading = true;
      this.$myApi.singleRequest({
        action: 'getEmail',
        mcode: this.managerCode
      }).then((res)=>{
        this.resultFind = `Email: ${res.email}`;
      }).catch((res)=>{
        this.resultFind = res;
      }).finally(()=>{
        this.loading = false
      })
    },
    updateUsers(){
      this.loading = true;
      this.$myApi.singleRequest({
        action: 'updateUsersList'
      }).then((res)=>{
        this.resultUpdate = res;
      }).catch((res)=>{
        this.resultUpdate = res;
      }).finally(()=>{
        this.loading = false
      })
    }
  }
}
</script>

<style scoped>

</style>